import { ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeQActionOrder,
  updateDonTaoLai,
  updateOpenCreateModal,
  updateOpenCreateOrderModal
} from '@slice/orderManager.slice';
import { Drawer } from 'rsuite';
import { Button, Divider, message } from 'antd';
import EnDeAES from 'helpers/EnDeAES';
import Helpers from 'helpers/Helpers';

export default function WapperDrawer({ children }: any) {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { t } = useTranslation();
  const [placement, setPlacement] = useState<any>('left');
  const openQActionOrder = useSelector((state: RootState) => state.orderManager.openQActionOrder);
  const orderCreateBase = useSelector((state: RootState) => state.orderManager.orderCreateBase);
  const uLogin = useSelector((state: RootState) => state.user.account);
  const rowSelected = useSelector((state: RootState) => state.orderManager.orderSelect);
  const checkThuNo = rowSelected?.orderType?.id !== 11;
  const isAccountant =
    (uLogin?.ActionOrder?.createOrderThuNo || uLogin?.ActionOrder?.createOrderChenhLech) &&
    rowSelected?.orderType?.id === 13;
  const isTechnician = uLogin?.role === 'Technician' && uLogin?.isGuiHang && rowSelected?.orderType?.id === 12;

  const refDataToHash = useRef<any>('');

  const onClose = () => {
    dispatch(changeQActionOrder(false));
  };

  const onReBaseCreate = () => {
    const data = {
      type: 'taolaidon',
      data: rowSelected
    };
    dispatch(changeQActionOrder(false));
    dispatch(updateOpenCreateOrderModal(true));
    dispatch(updateDonTaoLai(data));
    dispatch(updateOpenCreateModal(false));
  };

  const onCopyOrder = async () => {
    const newData = {
      ...refDataToHash.current,
      thoiGianDongPhi: Helpers.ConvertAdd7Hours(refDataToHash.current?.thoiGianDongPhi, 7, 'add'),
      thoiGianHetHan: Helpers.ConvertAdd7Hours(refDataToHash.current?.thoiGianHetHan, 7, 'add')
    };
    const jsonString = JSON.stringify(newData);
    const dateEn = await EnDeAES.encodeBase64(EnDeAES.aesEncrypt(jsonString));
    console.log('dateEn test', orderCreateBase, dateEn);
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(dateEn);
    } else {
      document.execCommand('copy', true, dateEn);
    }
    message.info(t('Drawer.Copied'));
  };

  // tạo style custom màu theo thêm luôn!!

  useEffect(() => {
    refDataToHash.current = orderCreateBase;
  }, [orderCreateBase]);

  return (
    <Drawer
      style={{
        zIndex: 40,
        width: '430px',
        minHeight: '450px',
        padding: '12px',
        bottom: '5px',
        right: '5px',
        position: 'absolute',
        backgroundColor: 'antiquewhite',
        borderTopLeftRadius: '5px'
      }}
      placement={placement}
      open={openQActionOrder}
      onClose={() => onClose()}
    >
      <div className="flex justify-between">
        <div className="font-semibold">{t('Drawer.Title')}</div>
        <div className="flex space-x-2">
          {checkThuNo && (
            <Button type="dashed" onClick={onCopyOrder}>
              {t('Drawer.CopyOrder')}
            </Button>
          )}

          {(uLogin.ActionOrder.createOrder || isAccountant || isTechnician) && (
            <Button type="primary" onClick={onReBaseCreate}>
              {rowSelected?.status.statusValue == '4' ? t('Drawer.ReBaseCreate') : t('Drawer.ReBaseEdit')}
            </Button>
          )}
          <Button onClick={onClose}>{t('Drawer.Cancel')}</Button>
        </div>
      </div>
      <Divider style={{ marginTop: 0, marginBottom: 0 }} />

      <div>{children}</div>
    </Drawer>
  );
}

// có thể làm tay nhưng thôi sài lib luôn kk mắc công canh chỉnh @#$%!!
// .menu__toggler {
//   position: absolute;
//   top: 20px;
//   left: 20px;
//   z-index: 999;
//   height: 28px;
//   width: 28px;
//   outline: none;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
// }
// .menu__toggler span,
// .menu__toggler span::before,
// .menu__toggler span::after {
//   position: absolute;
//   content: '';
//   width: 28px;
//   height: 2.5px;
//   background: #fafafa;
//   border-radius: 20px;
//   transition: 500ms cubic-bezier(0.77, 0, 0.175, 1);
// }
// .menu__toggler span::before {
//   top: -8px;
// }
// .menu__toggler span::after {
//   top: 8px;
// }
// .menu__toggler.active > span {
//   background: transparent;
// }
// .menu__toggler.active > span::before, .menu__toggler.active > span::after {
//   background: #005c9c;
//   top: 0px;
// }
// .menu__toggler.active > span::before {
//   -webkit-transform: rotate(-225deg);
//           transform: rotate(-225deg);
// }
// .menu__toggler.active > span::after {
//   -webkit-transform: rotate(225deg);
//           transform: rotate(225deg);
// }

// .menu {
//   position: absolute;
//   left: -30%;
//   z-index: 998;
//   color: #005c9c;
//   background: rgba(250, 250, 250, 0.7);
//   -webkit-clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
//           clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
//   width: 30%;
//   height: 100%;
//   padding: 100px;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   transition: 300ms left cubic-bezier(0.77, 0, 0.175, 1);
// }
// @media only screen and (max-width: 600px) {
//   .menu {
//     width: 250px;
//     left: -250px;
//     padding: 50px;
//   }
// }
// .menu.active {
//   left: 0;
// }
// .menu p {
//   font-size: 1.4rem;
//   margin-bottom: 1rem;
// }

// <div class="menu">
//   <p>Home</p>
//   <p>CSSSCRIPT.COM</p>
//   <p>About Us</p>
// </div>
// <div class="menu__toggler"><span></span></div>
